export default {
  'pc_monetization_revenue': '收入({unit})',
  'pc_monetization_revenue_sum': '总收入({unit})',
  'pc_monetization_net_revenue': '收入(剔除退款&税)({unit})',
  'pc_monetization_net_revenue_sum': ' 收入(剔除退款&税)汇总({unit})',
  'pc_monetization_units': '本体拷贝销售数',
  'pc_monetization_units_sum': '总本体拷贝销售数',
  'pc_monetization_full_units': '本体拷贝净销量',
  'pc_monetization_full_units_sum': '本体拷贝净销量汇总',
  'pc_monetization_mtx_Revenue($)': '内购收入({unit})',
  'pc_monetization_mtx_Revenue': '内购收入',
  'pc_monetization_mtx_ARPU_title': '内购ARPU & 内购付费ARPPU',
  'pc_monetization_mtx_ARPU': '内购ARPU({unit})',
  'pc_monetization_mtx_ARPPU': '内购付费ARPPU({unit})',
  'pc_monetization_revenue_Payer_And_Payer%': '内购付费人数和内购付费渗透率',
  'pc_monetization_revenue_Payer': '内购付费人数',
  'pc_monetization_revenue_Payer%': '内购付费渗透率',
  'pc_monetization_mtx_revenue_platform_distribution': '内购收入平台渠道构成',
  'pc_monetization_mtx_Rev': '内购收入({unit})',
  'pc_monetization_mtx_Rev_sum': '总内购收入({unit})',

  'pc_monetization_mtx_arpu': '内购ARPU({unit})',
  'pc_monetization_mtx_arpu_avg': '平均内购ARPU({unit})',
  'pc_monetization_mtx_arpu_avg_day': '日平均内购ARPU({unit})',
  'pc_monetization_mtx_arpu_avg_week': '周平均内购ARPU({unit})',
  'pc_monetization_mtx_arpu_avg_month': '月平均内购ARPU({unit})',

  'pc_monetization_mtx_arppu': '内购付费ARPPU({unit})',
  'pc_monetization_mtx_arppu_avg': '平均内购付费ARPPU({unit})',
  'pc_monetization_mtx_arppu_avg_day': '日平均内购付费ARPPU({unit})',
  'pc_monetization_mtx_arppu_avg_week': '周平均内购付费ARPPU({unit})',
  'pc_monetization_mtx_arppu_avg_month': '月平均内购付费ARPPU({unit})',

  'pc_monetization_mtx_payer': '内购付费人数',
  'pc_monetization_mtx_payer_avg': '平均内购付费人数',
  'pc_monetization_mtx_payer_avg_day': '日平均内购付费人数',
  'pc_monetization_mtx_payer_avg_week': '周平均内购付费人数',
  'pc_monetization_mtx_payer_avg_month': '月平均内购付费人数',

  'pc_monetization_mtx_payer_rate': '内购付费渗透率',
  'pc_monetization_mtx_payer_rate_avg': '平均内购付费渗透率',
  'pc_monetization_mtx_payer_rate_avg_day': '日平均内购付费渗透率',
  'pc_monetization_mtx_payer_rate_avg_week': '周平均内购付费渗透率',
  'pc_monetization_mtx_payer_rate_avg_month': '月平均内购付费渗透率',

  'pc_monetization_MTX_Revenue': '内购收入({unit})',
  'pc_monetization_MTX_Revenue_title': '内购收入',
  'pc_monetization_MTX_ARPU': '内购ARPU({unit})',
  'pc_monetization_MTX_ARPU_title': '内购ARPU',
  'pc_monetization_MTX_ARPPU': '内购付费ARPPU({unit})',
  'pc_monetization_MTX_ARPPU_title': '内购付费ARPPU',

  // dl2特殊配置
  'pc_monetization_mtx_Rev_dl2': 'MTX 收入({unit})',
  'pc_monetization_mtx_Rev_sum_dl2': '总 MTX 收入({unit})',

  'pc_monetization_MTX_Revenue_dl2': 'MTX 收入({unit})',
  'pc_monetization_MTX_Revenue_title_dl2': 'MTX 收入',
  'pc_monetization_MTX_ARPU_dl2': 'ARPU({unit})',
  'pc_monetization_MTX_ARPU_title_dl2': 'ARPU',
  'pc_monetization_MTX_ARPPU_dl2': 'ARPPU({unit})',
  'pc_monetization_MTX_ARPPU_title_dl2': 'ARPPU',

  'pc_monetization_mtx_arpu_dl2': 'ARPU({unit})',
  'pc_monetization_mtx_arpu_avg_dl2': '平均ARPU({unit})',

  'pc_monetization_mtx_arppu_dl2': 'ARPPU({unit})',
  'pc_monetization_mtx_arppu_avg_dl2': '平均ARPPU({unit})',

  'pc_monetization_mtx_payer_dl2': '付费人数',
  'pc_monetization_mtx_payer_avg_dl2': '平均付费人数',

  'pc_monetization_mtx_payer_rate_dl2': '付费渗透率',
  'pc_monetization_mtx_payer_rate_avg_dl2': '平均付费渗透率',

  'pc_console_revenue_net_units_category_title': '各类产品本体拷贝销售数',
  'pc_console_revenue_net_units_product_title': '各产品本体拷贝净销售数',
  'pc_console_revenue_net_units': '本体拷贝销售数',
  'pc_console_revenue_net_revenue_category_title': '各类产品收入(剔除退款&税)',
  'pc_console_revenue_net_revenue_product_title': '各类产品收入(剔除退款&税)',
  'pc_console_revenue_net_revenue': '收入({unit})',

  'pc_console_revenue_step': '步骤',
  'pc_console_revenue_conversion%': '转化率',
  'pc_console_revenue_users': '用户',
  'pc_console_revenue_conversion_&_counts': '转化率',

  'pc_console_revenue_total_mtx_revenue': '累计内购收入({unit})',
  'pc_console_revenue_total_mtx_payers': '累计内购付费用户数',
  'pc_console_revenue_total_mtx_payer_rate': '累计内购付费渗透率',
  'pc_console_revenue_mtx_revenue': '内购收入',

  'pc_console_revenue_mtx_arpu': '内购ARPU',
  'pc_console_revenue_mtx_arppu': '内购付费ARPPU',
  'pc_console_revenue_mtx_payers': '内购付费人数',

  'pc_console_revenue_mtx_payer_rate': '内购付费渗透率',
  'pc_console_revenue_new_user_mtx_payer_rate': '内购付费渗透率（新进用户）',
  'pc_console_revenue_mtx_new_paid_users': '首次内购用户',

  'pc_console_revenue_mtx_new_pay_amount': '首次内购收入({unit})',
  'pc_console_revenue_mtx_new_arpu': '首次内购用户ARPU({unit})',
  'pc_console_revenue_new_user_arpu': '新进用户付费ARPU({unit})',
  'pc_console_revenue_total_pay_days': '所有用户累计付费天数',

  'pc_console_revenue_30d_ltv': '30天内购LTV',
  'pc_console_revenue_180d_ltv': '180天内购LTV',
  'pc_console_revenue_overview_overall_performance': '指标总体表现',

  'pc_console_revenue_breakdown_net_revenue': '收入(剔除退款&税)({unit})',
  'pc_console_revenue_units_net_revenue': '本体拷贝收入(剔除退款&税)({unit})',
  'pc_console_revenue_dlc_net_revenue': 'DLC 净收入({unit})',
  'pc_console_revenue_net_units_count': '本体拷贝净销售数',
  'pc_console_revenue_avg_net_price': '产品净销售均价',
  'pc_console_revenue_gross_revenue': '总收入({unit})',
  'pc_console_revenue_gross_units_sold': '总销量',
  'pc_console_revenue_gross_base_game_units': '本体销量',
  'pc_console_sales_overview_refund_revenue_currency': '退款收入({unit})',

  'pc_console_revenue_sales_revenue': '系统销售收入',
  'pc_console_revenue_sales_breakdown': '系统销售构成',
  'pc_console_revenue_ingame_revenue': '游戏内收入',
  'pc_console_revenue_ingame_breakdown': '游戏内收入构成',


  'pc_console_revenue_units_dlc_rev': '收入(剔除退款&税)({unit})',
  'pc_console_revenue_units_dlc_rev_title': '收入(剔除退款&税)',
  'pc_console_revenue_units_net_rev': '本体拷贝收入({unit})',
  'pc_console_revenue_units_net_rev_title': '本体拷贝收入',
  'pc_console_revenue_dlc_net_rev': 'DLC 收入({unit})',
  'pc_console_revenue_dlc_net_rev_title': 'DLC 收入',
  'pc_console_revenue_unit': '本体拷贝销售数',

  'pc_console_revenue_units_dlc_rev_trends': '收入(剔除退款&税)趋势',
  'pc_console_revenue_units_net_rev_trends': '本体拷贝收入趋势',
  'pc_console_revenue_dlc_net_rev_trends': 'DLC 收入趋势',
  'pc_console_revenue_unit_trends': '本体拷贝销售数趋势',


  'pc_console_revenue_breakdown_category': '产品类型',
  'pc_console_revenue_breakdown_product': '产品',
  'pc_console_revenue_breakdown_net_rev_share': '全局占比(收入(剔除退款&税))',
  'pc_console_revenue_breakdown_net_unit_share': '全局占比(本体拷贝净销售数)',

  'pc_console_revenue_breakdown_total_net_unit_of_category': '各类产品本体拷贝净销售数',
  'pc_console_revenue_breakdown_total_net_revenue_of_category': '各类产品总收入(剔除退款&税)',

  'pc_console_revenue_breakdown_total_net_unit_of_product': '各产品本体拷贝净销售数',
  'pc_console_revenue_breakdown_total_net_revenue_of_product': '各产品总收入(剔除退款&税)',

  // Sales Overview
  'pc_console_revenue_sales_overview_tab': '销售概览',
  'pc_console_revenue_sales_breakdown_tab': '销售构成',
  'pc_console_revenue_product_analysis_tab': '产品分析',
  'pc_console_revenue_full_game_units': '本体拷贝净销量',
  'pc_console_revenue_sum_full_game_units': '本体拷贝净销量汇总',
  'pc_console_sales_overview_revenue': '收入(剔除退款&税)({unit})',
  'pc_console_sales_overview_revenue_title': '收入(剔除退款&税)',
  'pc_console_sales_overview_net_units': '净销量',
  'pc_console_sales_overview_net_full_game_revenue': '本体拷贝收入(剔除退款&税)({unit})',

  'pc_console_revenue_sum_full_game_units_revenue': '本体拷贝净销量汇总',
  'pc_console_sales_overview_sum_net_revenue': '收入(剔除退款&税)汇总({unit})',
  'pc_console_revenue_sum_net_units': '净销量汇总',
  'pc_console_revenue_sum_net_full_game_revenue': '本地拷贝收入(剔除退款&税)汇总({unit})',
  'pc_console_revenue_sum_gross_units': '本地拷贝销售数汇总',
  'pc_console_revenue_sum_gross_full_game_units': '本体销量汇总',
  'pc_console_revenue_sum_refunded_units': '退款数汇总',
  'pc_console_revenue_sum_gross_revenue': '总收入汇总({unit})',
  'pc_console_revenue_sum_refund_revenue': '退款收入汇总({unit})',
  'pc_console_revenue_top_10_revenue': 'TOP 10 收入(剔除退款&税)产品',
  'pc_console_revenue_top_10_product_unit': 'TOP 10 本体拷贝销售数产品',
  'pc_console_revenue_top_10_product_revenue': 'TOP 10 收入(剔除退款&税)产品',
  'pc_console_revenue_top_10_category_unit': 'TOP 10 本体拷贝销售数产品类型',
  'pc_console_revenue_top_10_category_revenue': 'TOP 10 收入(剔除退款&税)产品类型',
  'pc_console_revenue_top_10_product': 'TOP 10 产品',
  'pc_console_revenue_top_10_category': 'TOP 10 产品类型',

  'pc_console_revenue_products': '产品',
  'pc_console_revenue_categories': '产品类型',
  'pc_console_revenue_numbers': '本体拷贝净销售数',
  'pc_console_sum': '汇总值',
  'pc_console_avg': '平均值',

  // 指标卡片
  'pc_console_sales_overview_net_units_sold': '净销量',
  'pc_console_sales_overview_gross_units_sold': '总销量',
  'pc_console_sales_overview_third_party_units': '第三方销量',
  'pc_console_sales_overview_gross_revenue': '总收入',

  'pc_console_sales_overview_units_number': '本体拷贝净销量',
  'pc_console_sales_overview_accumulated_units': '本体拷贝总销量',
  'pc_console_sales_overview_net_revenue': '收入(剔除退款&税)',
  'pc_console_sales_overview_accumulated_revenue': '总收入',
  'pc_console_sales_overview_asp': '平均销售价格',
  'pc_console_sales_overview_refund_rate': '累计退款率',
  'pc_console_sales_overview_left_time_refund_rate': '累计退款率',
  'pc_console_sales_overview_refund_revenue': '退款收入',
  'pc_console_sales_overview_refunded_units': '退款数',
  'pc_console_sum_third_party_units': '第三方销量汇总',
  'pc_console_sum_accumaulated_refund_rate': '累计退款率',
  'pc_console_sum_avg_selling_price_asp': '平均销售价格',
};